module.exports = __webpack_public_path__ + "static/img/712-2.f648876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/m712/712-2.jpg
// module id = 5pL3
// module chunks = 0